
import { defineComponent, computed, ref, onMounted, onUnmounted } from 'vue'
import { useStore } from '@/store'
import { Slide } from '@/types/slides'
import { message, Modal } from 'ant-design-vue'
// 引入接口
import { SpaceService } from '@/api/space'
import { LazyImg, Waterfall } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import { getFileWidthAndHeight } from '@/utils/image'
export default defineComponent({
  name: 'Template',
  components: {
    Waterfall,LazyImg
  },
  setup() {
    const store = useStore()
    const templates = computed<Slide[]>(() => store.getters.templates)
    const tabKey = ref ('zuopin')
    const currHistroy = ref('作品')
    const currRemoveFolder = ref(0)
    const currRemoveTemplate = ref('')
    const currRemoveType = ref(1)
    const currFolder = ref({name: "", id: ''})
    const currOrder = ref('modifyDateDesc')
    const folderId = ref('')
    const folderName = ref ('')
    const folderTitle = ref ('创建文件夹')
    const templateName = ref('')
    const currSlide = ref()
    const imagesVisible = ref(false)
    const removeVisible = ref(false)
    const renameVisible = ref(false)
    const uploadVisible = ref(false)
    const isBatchShow = ref(false)
    const isEmpty = ref(false)
    const spinning = ref(false)
    const over = ref(false)
    const colWidth = ref(280)
    const breakpoints = {
      3000: { // 当屏幕宽度小于等于1200
        rowPerView: 6,
      },
    }
    const tabList = [
      {
        key: 'zuopin',
        tab: '作品',
      },
      {
        key: 'sucai',
        tab: '素材',
      },
      {
        key: 'recycle',
        tab: '回收站',
      },
    ]
    const folderList = ref([])
    const histroyList = [
      {
        key: 'zuopin',
        tab: '作品',
      },
      {
        key: 'sucai',
        tab: '素材',
      }
    ]
    const materialList = ref([])
    const templateList = ref([])
    const checkedMaterialList = ref([])
    const checkedTemplateList = ref([])
    const isAllChecked = ref(false)
    const checkedLength = ref(0)
    const isTemplateAllChecked = ref(false)
    const materialHistroyList = ref([])
    const templateHistroyList = ref([])
    const checkedMaterialHistroyList = ref([])
    const checkedTemplateHistroyList = ref([])
    const pageSize = ref(36)
    const pageNumber = ref(1)
    const pageSum = ref(0)
    const loading = ref(false)
    const total = ref({user_material_total:0,user_ppt_total:0,recycled_total:0})
    const windowResizeListener = () => {
      colWidth.value = (document.getElementsByClassName('space-wrapper')[0].clientWidth / 6) - 12
    }

  
    const isMounted = ref(false)
    const forUpdate = ref(0)
    const isLimit = ref(true)
    onMounted(() => {
      windowResizeListener()
      window.addEventListener('resize', windowResizeListener)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', windowResizeListener)
    })
    
    const onTabChange = (key: any,) => {
      pageSize.value = 36
      pageNumber.value = 1
      pageSum.value = 0
      tabKey.value = key
      checkedMaterialList.value = []
      checkedTemplateList.value = []
      materialHistroyList.value = []
      templateHistroyList.value = []
      materialList.value = []
      templateList.value = []
      folderList.value = []
      isAllChecked.value = false
      checkedLength.value = 0
      currFolder.value = {name: "", id: ''}
      if (tabKey.value === 'sucai') {
        getUserMaterialList()
        checkedMaterialList.value = []
        isAllChecked.value = false
        materialList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        isTemplateAllChecked.value = false
        getFolderList()
        templateList.value.forEach((item:any) => {
          item.checked = false
        })
        reloadTemplateList()
      }
      if (tabKey.value === 'recycle') {
        templateHistroyList.value = []
        currHistroy.value = '作品'
        getTemplateHistroyList()
      }
      isBatchShow.value = false
    }
    const showFolderModal = () => {
      imagesVisible.value = true
      folderName.value = ''
      folderTitle.value = '创建文件夹'
    }
    const showRemoveModal = (slide:any, type:any) => {
      currRemoveTemplate.value = slide.id
      currRemoveType.value = type
      removeVisible.value = true
    }
    const closeModal = () => {
      imagesVisible.value = false
      renameVisible.value = false
      removeVisible.value = false
      uploadVisible.value = false
    }
    const onDelFolder = async (item:any) => {
      const params = {
        folderId:item.id
      }
      const res = await SpaceService.deleteFolder(params)
      if (res.data.state === 2) {
        message.success(res.data.msg)
      }
      else {
        message.error(res.data.msg)
      }
      getFolderList()
    } 
    const addFolder = async () => {
      imagesVisible.value = false
      if (folderTitle.value === '重命名文件夹') {
        const params = {
          id:folderId.value,
          name:folderName.value
        }
        const res = await SpaceService.renameFolder(params)
        if (res.data.state === 2) {
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }
        getFolderList()
      }
      else {
        const params = {
          name:folderName.value,
          parentId:currFolder.value.id
        }
        const res = await SpaceService.addFolder(params)
        if (res.data.state === 2) {
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }
      }

      getFolderList()
    }
    const changeInput = (e: { target: { value: any } }) => {
      folderName.value = e.target.value
    }
    const changeInputRename = (e: { target: { value: any } }) => {
      templateName.value = e.target.value
    }
    const onRenameFolder = (item: any) => {
      imagesVisible.value = true
      folderName.value = item.name
      folderTitle.value = '重命名文件夹'
      folderId.value = item.id

    }
    const getMaterialHistroyList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getMaterialHistroyList(params)
      materialHistroyList.value = materialHistroyList.value.concat(res.data.data)
      pageSum.value = res.data.pageSum
      res.data.data.forEach((item:any) => {
        item.checked = false
      })
      if (materialHistroyList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }
    const getTemplateHistroyList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getTemplateHistroyList(params)
      templateHistroyList.value = templateHistroyList.value.concat(res.data.data)
      res.data.data.forEach((item:any, ind:number) => {
        item.checked = false
        item.ind = ind
        if (item.preview === null || item.preview === 'null') {
          item.preview = 'http://file.101dao.com/files/upload/material_file/202205/2c2dba4d-4d8c-4887-83d7-9a1d4cdc4e68.png'
        }
      })
      if (templateHistroyList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }    
    const getUserMaterialList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value
      }
      const res = await SpaceService.getUserMaterialList(params)
      res.data.data.forEach((item:any) => {
        item.thumbUrl = item.url
        item.uid = item.id
        item.status = 'done'
        item.checked = false
      })
      materialList.value = materialList.value.concat(res.data.data)
      pageSum.value = res.data.pageSum
      if (materialList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }
    const getUserTemplateList = async () => {
      const params = {
        pageSize:pageSize.value,
        pageNumber:pageNumber.value,
        folderId:currFolder.value.id || -1,
        orderType:currOrder.value
      }
      const res = await SpaceService.getUserTemplateList(params)
      templateList.value = templateList.value.concat(res.data.data)
      templateList.value.forEach((item:any,ind:number) => {
        item.checked = false
        item.ind = ind
        if (item.preview === null || item.preview === 'null') {
          item.preview = 'http://file.101dao.com/files/upload/material_file/202205/2c2dba4d-4d8c-4887-83d7-9a1d4cdc4e68.png'
        }
      })
      pageSum.value = res.data.pageSum
      if (templateList.value.length <= 0) {
        isEmpty.value = true
        spinning.value = false
      }
      else {
        isEmpty.value = false
        spinning.value = false
      }
    }    
    const onDeleteChange = (ind: any) => {
      isBatchShow.value = true
      if (tabKey.value === 'sucai') {
        checkedMaterialList.value = []
        materialList.value.forEach((item:any, index) => {
          if (index === ind) {
            item.checked = !item.checked
            
          }
          if (item.checked) {
            checkedMaterialList.value.push(item.id as never)
          }
        })
        checkedLength.value = checkedMaterialList.value.length
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        templateList.value.forEach((item:any, index: any) => {
          if (index === ind) {
            item.checked = !item.checked
          }
          if (item.checked) {
            checkedTemplateList.value.push(item.id as never)
          }
        })

        checkedLength.value = checkedTemplateList.value.length
      }
      if (tabKey.value === 'recycle') {
        if (currHistroy.value === '作品') {
          checkedTemplateHistroyList.value = []
          templateHistroyList.value.forEach((item:any, index: any) => {
            if (index === ind) {
              item.checked = !item.checked
              
            }
            if (item.checked) {
              checkedTemplateHistroyList.value.push(item.id as never)
            }
          })
          checkedLength.value = checkedTemplateHistroyList.value.length
        }
        if (currHistroy.value === '素材') {
          checkedMaterialHistroyList.value = []
          materialHistroyList.value.forEach((item:any, index: any) => {
            if (index === ind) {
              item.checked = !item.checked
              
            }
            if (item.checked) {
              checkedMaterialHistroyList.value.push(item.id as never)
            }
          })
          checkedLength.value = checkedMaterialHistroyList.value.length
        }

      }
    }
    const onDeleteAllChange = (type:any, state: any) => {
      if (type === 'sucai') {
        checkedMaterialList.value = []
        if (!state) {
          materialList.value.forEach((item:any) => {
            if (checkedMaterialList.value.length < materialList.value.length) {
              item.checked = true
              isAllChecked.value = true
            }
            
            if (item.checked) {
              checkedMaterialList.value.push(item.id as never)
            }
          })
          
        }
        else {
          materialList.value.forEach((item:any) => {
            item.checked = false
            isAllChecked.value = false
          })
        }
        checkedLength.value = checkedMaterialList.value.length
      }
      if (type === 'zuopin') {

        checkedTemplateList.value = []
        if (!state) {
          templateList.value.forEach((item:any) => {
            if (checkedTemplateList.value.length < templateList.value.length) {
              item.checked = true
              isAllChecked.value = true
            }
            
            if (item.checked) {
              checkedTemplateList.value.push(item.id as never)
            }
          })
        }
        else {
          templateList.value.forEach((item:any) => {
            item.checked = false
            isAllChecked.value = false
          })
        } 
        checkedLength.value = checkedTemplateList.value.length
        windowResizeListener()
      }
      if (type === 'recycle') {
        if (currHistroy.value === '作品') {
          checkedTemplateHistroyList.value = []
          if (!state) {
            templateHistroyList.value.forEach((item:any) => {
              if (checkedTemplateHistroyList.value.length < templateHistroyList.value.length) {
                item.checked = true
                isAllChecked.value = true
              }
              
              if (item.checked) {
                checkedTemplateHistroyList.value.push(item.id as never)
              }
            })
          }
          else {
            templateHistroyList.value.forEach((item:any) => {
              item.checked = false
              isAllChecked.value = false
            })
          } 
          checkedLength.value = checkedTemplateHistroyList.value.length
        }
        if (currHistroy.value === '素材') {
          checkedMaterialHistroyList.value = []
          if (!state) {
            materialHistroyList.value.forEach((item:any) => {
              if (checkedMaterialHistroyList.value.length < materialHistroyList.value.length) {
                item.checked = true
                isAllChecked.value = true
              }
              
              if (item.checked) {
                checkedMaterialHistroyList.value.push(item.id as never)
              }
            })
          }
          else {
            materialHistroyList.value.forEach((item:any) => {
              item.checked = false
              isAllChecked.value = false
            })
          } 
          checkedLength.value = checkedMaterialHistroyList.value.length
        }
      }
    }
    const outDeleteAllChange = () => {
      isBatchShow.value = false
      if (tabKey.value === 'sucai') {
        checkedMaterialList.value = []
        isAllChecked.value = false
        materialList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'zuopin') {
        checkedTemplateList.value = []
        isTemplateAllChecked.value = false
        templateList.value.forEach((item:any) => {
          item.checked = false
        })
      }
      if (tabKey.value === 'recycle') {
        checkedTemplateHistroyList.value = []
        isTemplateAllChecked.value = false
        templateHistroyList.value.forEach((item:any) => {
          item.checked = false
        })
        checkedMaterialHistroyList.value = []
        isAllChecked.value = false
        materialHistroyList.value.forEach((item:any) => {
          item.checked = false
        })
      }
    }
    const onRestore = async (id: string) => {
      const params = {
        ids:''
      }
      if (currHistroy.value === '素材') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedMaterialHistroyList.value.join(',')
        }
        const res = await SpaceService.showMaterial(params)  
        if (res.data.state === 2) {
          materialHistroyList.value = []
          pageNumber.value = 1
          getMaterialHistroyList()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }   
        
      }
      if (currHistroy.value === '作品') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedTemplateHistroyList.value.join(',')
        }
        const res = await SpaceService.showTemplate(params)  
        if (res.data.state === 2) {
          getTemplateHistroyList()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
    }
    const onDelete = (key: string, id: string) => {
      Modal.confirm({
        title: '删除提示',
        content: key === 'recycle' ? '删除资源后将无法重新找回，请谨慎操作！' : '是否确定要转移到回收站？',
        okText:'确定删除',
        cancelText:'取消',
        onOk() {

          return new Promise((resolve, reject) => {
            const res = confirmOnOk(resolve, reject, key, id)
            return res
          })
        },
      })
    }
    const confirmOnOk = async (resolve:any, reject:any, key:string, id:string) => {
      const params = {
        ids:''
      }
      if (key === 'sucai') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedMaterialList.value.join(',')
        }
        
        const res = await SpaceService.hideMaterial(params)  
        if (res.data.state === 2) {
          resolve()
          outDeleteAllChange()
          materialList.value = []
          pageNumber.value = 1
          getUserMaterialList()
          getToatl()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
      if (key === 'zuopin') {
        if (id) {
          params.ids = id
        }
        else {
          params.ids = checkedTemplateList.value.join(',')
        }
        const res = await SpaceService.hideTemplate(params)  
        if (res.data.state === 2) {
          resolve()
          outDeleteAllChange()
          reloadTemplateList()
          getTemplateHistroyList()
          getToatl()
          message.success(res.data.msg)
        }
        else {
          message.error(res.data.msg)
        }  
      }
      if (key === 'recycle') {
        if (currHistroy.value === '素材') {
          if (id) {
            params.ids = id
          }
          else {
            params.ids = checkedMaterialHistroyList.value.join(',')
          }
          const res = await SpaceService.delMaterial(params)  
          if (res.data.state === 2) {
            resolve()
            materialHistroyList.value = []
            pageNumber.value = 1
            getMaterialHistroyList()
            outDeleteAllChange()
            getToatl()
            message.success(res.data.msg)
          }
          else {
            message.error(res.data.msg)
          }  
        }
        if (currHistroy.value === '作品') {
          if (id) {
            params.ids = id
          }
          else {
            params.ids = checkedTemplateHistroyList.value.join(',')
          }
          const res = await SpaceService.delTemplate(params)  
          if (res.data.state === 2) {
            resolve()
            templateHistroyList.value = []
            pageNumber.value = 1
            outDeleteAllChange()
            getTemplateHistroyList()
            getToatl()
            message.success(res.data.msg)
          }
          else {
            message.error(res.data.msg)
          }  
        }
      }
    }
    const onChangeHistroy = (data:any) => {
      currHistroy.value = data.tab
      outDeleteAllChange()
      if (data.key === 'sucai') {
        materialHistroyList.value = []
        pageNumber.value = 1
        getMaterialHistroyList()
      }
      else {
        templateHistroyList.value = []
        pageNumber.value = 1
        getTemplateHistroyList()
      }
      
    }
    const showBatch = () => {
      isBatchShow.value = !isBatchShow.value
    }
    const getFolderList = async () => {
      const params = {
        parentId:currFolder.value.id,
      }
      const res = await SpaceService.folderList(params)
      folderList.value = res.data.data
    }
    const getToatl = async () => {
      const params = {
      }
      const res = await SpaceService.pptTotal(params)
      total.value = res.data.data
    }
    const clickRemoveFolder = (item:any) => {
      currRemoveFolder.value = item.id
    }
    const removeFolder = async () => {
      if (currRemoveFolder.value < -1) {
        message.error('请选择要移动的文件夹')
        return
      }
      if (currRemoveType.value === 1) {
        const params = {
          folderId:currRemoveFolder.value,
          contentIds:currRemoveTemplate.value
        }
        const res = await SpaceService.movesFolder(params)
        if (res.data.state === 2) {
          message.success('移动成功')
          outDeleteAllChange()
          getFolderList()
          reloadTemplateList()
          removeVisible.value = false
        }
        else {
          message.error(res.data.msg)
        }
      }
      else {
        const params = {
          folderId:currRemoveFolder.value,
          contentIds:checkedTemplateList.value.join(',')
        }
        const res = await SpaceService.movesFolder(params)
        if (res.data.state === 2) {
          message.success('移动成功')
          outDeleteAllChange()
          getFolderList()
          reloadTemplateList()
          removeVisible.value = false
        }
        else {
          message.error(res.data.msg)
        }
      }

    }
    const clickFolder = (item:any) => {
      currFolder.value = item
      reloadTemplateList()
      getFolderList()
    }
    const showAllFolder = () => {
      currFolder.value = {name: "", id: ''}
      getFolderList()
      reloadTemplateList()
    }
    const reloadTemplateList = () => {
      templateList.value = []
      pageNumber.value = 1
      over.value = false
      getUserTemplateList()
    }

    const onOrder = (type:any) => {
      currOrder.value = type
      reloadTemplateList()
    }
    const onCopy = async (id:any) => {
      const params = {
        id:id
      }
      const key = 'updatable'
      message.loading({content:'复制内容中..', key})
      const res = await SpaceService.copyTemplate(params)
      if (res.data.state === 2) {
        message.success({content:'创建副本成功', key})
        reloadTemplateList()
        getToatl()
      }
      else {
        message.error(res.data.msg)
      }
    }
    const onRenameShow = (slide:any) => {
      currSlide.value = slide
      renameVisible.value = true
      templateName.value = slide.title

    }
    const onRename = async () => {
      const params = {
        id:currSlide.value.id,
        name:templateName.value
      }
      const key = 'updatable'
      message.loading({content:'修改名称中..', key})
      const res = await SpaceService.renameTemplate(params)
      if (res.data.state === 2) {
        message.success({content:'修改成功', key})
        reloadTemplateList()
      }
      else {
        message.error(res.data.msg)
      }
      renameVisible.value = false
    }
    const onScroll = () => {

      if (
        document.documentElement.scrollTop + document.documentElement.clientHeight >=
        document.documentElement.scrollHeight
      ) {
      
        if (pageNumber.value >= pageSum.value) {
          return false
        }
        
        pageNumber.value++
        spinning.value = true
        if (tabKey.value === 'zuopin') {
          getUserTemplateList()
        }
        if (tabKey.value === 'sucai') {
          getUserMaterialList()
        }
        if (tabKey.value === 'recycle') {
          if (currHistroy.value === '素材') {
            getMaterialHistroyList()
          }
        }
      }
    }
    const showSucaiUpload = () => {
      uploadVisible.value = true
    }
    const params = ref()
    const headers = ref({
      token: computed(() => store.state.token) || ''
    })
    
    let hide:any = null
    const handleChange = (info: any) => {
      if (info.file.status !== 'uploading') {
        closeModal()
      }
      if (info.file.status === 'done') {
        setTimeout(hide, 1)
        setTimeout(message.success(`${info.file.name} 上传成功！`), 500)
        materialList.value = []
        pageNumber.value = 1
        getUserMaterialList()

      }
      else if (info.file.status === 'error') {
        setTimeout(hide, 1)
        message.error(`${info.file.name} 上传失败！`)
      }
    }
    const beforeUpload = (file: any) => {
      hide = message.loading('正在上传中..', 0)
      let type = 'png'
      if (file.type === 'image/jpeg') {
        type = 'jpg'
      }
      else if (file.type === 'image/png') {
        type = 'png'
      }
      else if (file.type === 'image/gif') {
        type = 'gif'
      }
      else {
        setTimeout(hide, 1)
        message.error('暂不支持的格式')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        setTimeout(hide, 1)
        message.error('上传文件大小不能超过 5MB!')
        return false
      }
      params.value = {
        height:'',
        width:'',
        type: type,
      }
      return getFileWidthAndHeight(file, 5000, 5000, hide)
      // const res = await UploadService.userMaterial(params)
    }
    onMounted(getUserTemplateList)
    window.addEventListener('scroll', onScroll)
    getFolderList()
    getToatl()
    return {
      folderTitle,
      folderName,
      tabKey,
      tabList,
      folderList,
      templates,
      materialList,
      imagesVisible,
      removeVisible,
      uploadVisible,
      showRemoveModal,
      templateList,
      onTabChange,
      closeModal,
      showFolderModal,
      addFolder,
      onDelFolder,
      onRenameFolder,
      changeInput,
      value: ref<string[]>([]),
      onDeleteChange,
      onDeleteAllChange,
      isAllChecked,
      checkedLength,
      isTemplateAllChecked,
      checkedTemplateList,
      checkedMaterialList,
      templateHistroyList,
      materialHistroyList,
      outDeleteAllChange,
      onDelete,
      onRestore,
      onChangeHistroy,
      histroyList,
      currHistroy,
      showBatch,
      isBatchShow,
      isEmpty,
      spinning,
      clickRemoveFolder,
      currRemoveFolder,
      removeFolder,
      currFolder,
      clickFolder,
      showAllFolder,
      currOrder,
      onOrder,
      onCopy,
      templateName,
      changeInputRename,
      onRenameShow,
      onRename,
      renameVisible,
      isLimit,
      isMounted,
      forUpdate,
      loading,
      over,
      colWidth,
      total,
      showSucaiUpload,
      handleChange,
      beforeUpload,
      params,
      headers,
      breakpoints
    }
  },
})
